import { render, staticRenderFns } from "./ledgers.vue?vue&type=template&id=11a62348"
import script from "./ledgers.ts?vue&type=script&lang=js&external"
export * from "./ledgers.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports